import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const MyPaymentsIcon: React.FC<SvgProps> = ({ strokeColor = '#CBD2D9' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 29.3327C23.3638 29.3327 29.3334 23.3631 29.3334 15.9994C29.3334 8.63555 23.3638 2.66602 16 2.66602C8.63622 2.66602 2.66669 8.63555 2.66669 15.9994C2.66669 23.3631 8.63622 29.3327 16 29.3327Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M19.8417 22.689C19.1638 23.141 18.0338 23.593 16.5875 23.593C15.1412 23.593 13.2429 22.915 12.1581 21.6495C11.3446 20.7455 10.8022 19.48 10.5762 17.8981H9.22028V16.8133H10.4858V16.4969C10.4858 16.1353 10.4858 15.2766 10.531 14.9602H9.22028V13.8755H10.6666C10.9378 12.3387 11.5706 11.0732 12.4745 10.1692C13.6045 8.9941 15.0056 8.36133 16.8135 8.36133C18.6214 8.36133 19.1186 8.72291 19.7062 9.03929L19.2542 10.4856C18.7118 10.1692 17.8078 9.85285 16.8135 9.85285C15.8191 9.85285 14.6892 10.2596 13.9208 11.0732C13.2429 11.706 12.8361 12.7003 12.6101 13.8303H18.7118V14.9602H12.4293C12.4293 15.2314 12.3841 16.1353 12.3841 16.4065V16.8133H18.7118V17.8981H12.5197C12.7005 19.1636 13.1525 20.1127 13.74 20.7455C14.5536 21.6043 15.6384 22.011 16.8135 22.011C17.9886 22.011 18.983 21.5591 19.4802 21.2879L19.8417 22.689Z"
      fill={strokeColor}
    />
  </svg>
);

export default MyPaymentsIcon;
